import { render } from "./ValidOtp.vue?vue&type=template&id=49246c06"
import script from "./ValidOtp.vue?vue&type=script&lang=js"
export * from "./ValidOtp.vue?vue&type=script&lang=js"
script.render = render

export default script